import React from 'react';
import { Briefcase, Building2, Sparkles, RefreshCw, HardHat, Wrench, ShoppingBag, Snowflake } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const ServicesSection = () => {
  const navigate = useNavigate();
  const services = [
    {
      icon: Briefcase,
      title: 'Büro- & Gewerbereinigung',
      description: 'Repräsentative Arbeitsräume für produktives Arbeiten. Gründliche Pflege von Büros, Küchen und Sanitärbereichen – zuverlässig außerhalb Ihrer Geschäftszeiten.',
      features: ['Flexible Reinigungszeiten', 'Diskretion & Zuverlässigkeit', 'Hygienische Standards'],
      image: 'https://images.unsplash.com/photo-1627905646269-7f034dcc5738',
    },
    {
      icon: Building2,
      title: 'Treppenhausreinigung',
      description: 'Der erste Eindruck zählt. Makellos gepflegte Treppenhäuser und Eingangsbereiche steigern die Zufriedenheit Ihrer Mieter und den Wert Ihrer Immobilie.',
      features: ['Regelmäßige Intervalle', 'Auch Aufzüge & Keller', 'Dokumentierte Leistung'],
      image: 'https://images.pexels.com/photos/6078750/pexels-photo-6078750.jpeg',
    },
    {
      icon: Sparkles,
      title: 'Glas- & Fensterreinigung',
      description: 'Streifenfrei saubere Fenster für perfekte Lichtverhältnisse. Professionelle Reinigung von Glas, Rahmen und Falzen – auch bei schwer zugänglichen Flächen.',
      features: ['Streifenfreie Reinigung', 'Schwer erreichbare Flächen', 'Inkl. Rahmen & Fensterbänke'],
      image: 'https://images.unsplash.com/photo-1482449609509-eae2a7ea42b7',
    },
    {
      icon: ShoppingBag,
      title: 'Ladenflächen- & Gastronomiereinigung',
      description: 'Saubere Geschäftsräume für zufriedene Kunden. Professionelle Reinigung von Ladenflächen, Restaurants und Cafés – Tische, Böden, Fenster und Sanitäranlagen.',
      features: ['Gastronomie & Einzelhandel', 'Flexible Zeiten', 'Hygiene nach HACCP'],
      image: 'https://images.unsplash.com/photo-1679872014670-cdec65d80321?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwY2xlYW5pbmd8ZW58MHx8fHwxNzYyMDkxOTI0fDA&ixlib=rb-4.1.0&q=85',
    },
    {
      icon: RefreshCw,
      title: 'Unterhaltsreinigung',
      description: 'Planbare Sauberkeit für Ihren Alltag. Regelmäßige, zuverlässige Pflege von Büros, Praxen und Geschäftsräumen mit transparenter Leistungsdokumentation.',
      features: ['Täglich bis monatlich', 'Feste Ansprechpartner', 'Individuelle Checklisten'],
      image: 'https://images.unsplash.com/photo-1603712725038-e9334ae8f39f',
    },
    {
      icon: Snowflake,
      title: 'Winterdienst',
      description: 'Sicher durch den Winter. Zuverlässige Schneeräumung und Streudienst für Ihre Immobilie – damit Gehwege, Einfahrten und Parkplätze jederzeit sicher begehbar sind.',
      features: ['Schneeräumung & Streudienst', 'Frühmorgens verfügbar', 'Verkehrssicherungspflicht'],
      image: 'https://images.unsplash.com/photo-1629818571630-5523061def62?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxzbm93JTIwcmVtb3ZhbHxlbnwwfHx8fDE3NjIwOTE5Mjl8MA&ixlib=rb-4.1.0&q=85',
    },
    {
      icon: HardHat,
      title: 'Bau- & Renovierungsreinigung',
      description: 'Perfekte Übergabe nach Bauarbeiten. Vom groben Bauschmutz bis zur Feinreinigung – wir übergeben Ihr Objekt bezugsfertig und makellos sauber.',
      features: ['Grob- bis Feinreinigung', 'Schnelle Abwicklung', 'Bezugsfertige Übergabe'],
      image: 'https://images.pexels.com/photos/6474206/pexels-photo-6474206.jpeg',
    },
    {
      icon: Wrench,
      title: 'Objektbetreuung & Facility Service',
      description: 'Rundum-Service für Ihre Immobilie. Hausmeisterdienste, Gartenpflege und Kleinreparaturen – alles aus einer Hand für eine gepflegte Immobilie.',
      features: ['Hausmeisterdienste', 'Kleinreparaturen', 'Regelmäßige Kontrollen'],
      image: 'https://images.unsplash.com/photo-1733286125300-b4c5563295ad',
    },
  ];

  return (
    <section id="services" className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 fade-in">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#0A2846] mb-6 px-2">
            Unsere Leistungen für Sie
          </h2>
          <div 
            className="w-24 sm:w-32 h-1.5 mx-auto mb-6 sm:mb-8 rounded-full"
            style={{ 
              background: 'linear-gradient(90deg, #D4AF37 0%, #FFD700 50%, #F4D03F 100%)',
              boxShadow: '0 4px 15px rgba(212, 175, 55, 0.4)'
            }} 
          />
          <p className="text-lg sm:text-xl text-[#1F2937] max-w-3xl mx-auto leading-relaxed px-4">
            Professionelle Reinigungslösungen für Gewerbe, Büros und Immobilien
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 group border border-gray-100 flex flex-col"
              >
                <div className="relative h-56 overflow-hidden flex-shrink-0">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A2846]/90 via-[#0A2846]/50 to-transparent" />
                  <div 
                    className="absolute bottom-4 left-4 w-14 h-14 rounded-full flex items-center justify-center"
                    style={{
                      background: 'linear-gradient(135deg, #D4AF37 0%, #FFD700 100%)',
                      boxShadow: '0 8px 20px rgba(212, 175, 55, 0.5)'
                    }}
                  >
                    <Icon className="w-7 h-7 text-[#0A2846]" />
                  </div>
                </div>
                <div className="p-6 flex-grow flex flex-col">
                  <h3 className="text-xl font-semibold text-[#0A2846] mb-3 leading-tight">{service.title}</h3>
                  <p className="text-[#1F2937]/80 leading-relaxed mb-4 flex-grow">{service.description}</p>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-sm text-[#1F2937]/70">
                        <div 
                          className="w-1.5 h-1.5 rounded-full mr-2"
                          style={{ background: 'linear-gradient(135deg, #D4AF37, #FFD700)' }}
                        />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12 sm:mt-16">
          <Button
            onClick={() => navigate('/kontakt')}
            className="w-full sm:w-auto font-semibold text-base sm:text-lg px-8 sm:px-10 py-5 sm:py-6 transition-all duration-300 hover:scale-105"
            style={{
              background: 'linear-gradient(135deg, #D4AF37 0%, #FFD700 50%, #F4D03F 100%)',
              color: '#0A2846',
              boxShadow: '0 8px 30px rgba(212, 175, 55, 0.5), 0 0 40px rgba(212, 175, 55, 0.3)'
            }}
          >
            Jetzt unverbindliches Angebot anfordern
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;